import React from 'react'
import { Base } from '@crossfit/ui'
import cx from 'classnames'

import style from './style.module.scss'

type FormProps = React.ComponentProps<typeof Base>

function Form({ className, children, as = 'form', ...props }: FormProps) {
  return (
    <Base {...props} as={as} className={cx(className, style.wrapper)}>
      {children}
    </Base>
  )
}

export default Form
